/** Optional absolute URL to the mail endpoint (e.g. another deployment). Default: same-origin `/api/send-mail`. */
const mailUrl = () =>
  import.meta.env.VITE_MAIL_API_URL?.trim() || '/api/send-mail'

export type SubmitResult = { ok: true } | { ok: false; error: string }

/** Same pattern as Quality-Painting/Website `components/quote-form.js` (no client abort timeout). */
export async function submitToMailer(body: object): Promise<SubmitResult> {
  let res: Response
  try {
    res = await fetch(mailUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
  } catch {
    return {
      ok: false,
      error: 'Network error. Please try again.',
    }
  }
  const data = (await res.json().catch(() => ({}))) as {
    ok?: boolean
    error?: string
  }
  if (!res.ok) {
    return {
      ok: false,
      error:
        typeof data.error === 'string'
          ? data.error
          : 'Something went wrong. Please try again.',
    }
  }
  if (data.ok === false) {
    return {
      ok: false,
      error:
        typeof data.error === 'string'
          ? data.error
          : 'Something went wrong. Please try again.',
    }
  }
  return { ok: true }
}
